/* globals jui, lp, Class, $H */
var _ = require('lodash');

lp.editor.ElementBoundaryControl = Class.create(jui.Component, jui.ControlModel, {
  options: function($super,options){
    return $super($H({attributes:{className:'element-boundary'}}).merge(options));
  },

  initialize: function($super, params){
    this.elm               = params.element;
    this.manager           = params.manager;
    this.onDrag            = params.onDrag;
    this.onInitDrag        = params.onInitDrag;
    this.onBeforeDrag      = params.onBeforeDrag;
    this.actsOn            = params.actsOn;
    this.axis              = params.axis || 'x';
    this._uiBinding        = params.uiBinding;
    this._rxUiSubscription = null;

    $super();

    this.e.addClassName(
      ' element-boundary-' + params.actsOn +
      ' element-boundary-' + (params.axis || 'x'));
    _.bindAll(this);
  },

  installUI: function($super, options) {
    $super(options);
    this.line = this.insert(new Element('div', {
      className: 'element-boundary-line-' + this.actsOn + ' element-boundary-line element-boundary-line-' + this.axis
    }));
    this.arrow = this.insert(new Element('div', {
      className: 'element-boundary-arrow-' + this.actsOn + ' element-boundary-arrow element-boundary-arrow-' + this.axis
    }));

      var handle = "";

      if(this.actsOn === "padding-top" || this.actsOn === "margin-bottom" ){
        handle =
          '<svg viewBox="0 0 100 56">' +
            '<path d="M94,2.5L50,49.5H6V2.5H94z M42.5,14.3H14.2 M42.5,37.7H14.2 M42.5,26H14.2"/>' +
          '</svg>';
      }else if(this.actsOn === "height"){
        handle =
          '<svg viewBox="0 0 100 56">' +
            '<path d="M6,51.5V4.5h44l44,46.9H6z M14.2,39.7h28.2 M14.2,16.3h28.2 M14.2,28h28.2"/>' +
          '</svg>';
      }else if(this.actsOn === "page-left"){
        handle =
          '<svg viewBox="0 0 56 100">' +
            '<path d="M53.5,92L6.5,48V4h46.9V92z M41.7,40.5V12.2 M18.3,40.5V12.2 M30,40.5V12.2"/>' +
          '</svg>';
      }else if(this.actsOn === "page-right"){
        handle =
          '<svg viewBox="0 0 56 100">' +
            '<path d="M2.5,4h46.9v44L2.5,92V4z M14.3,12.2v28.2 M37.7,12.2v28.2 M26,12.2v28.2"/>' +
          '</svg>';
      }

      if( ! _.isEmpty(handle)) {
        this.arrow.update(handle);
      }

    var startElements = [this.arrow, this.e],
        self          = this;

    this._rxUiSubscription =
      this._uiBinding.bindDrag(startElements, null, {elementId: this.elm.id})
        .filter(function(ev) {
          return ev.elementId === self.elm.id;
        })
        .ub_subscribe(function (ev) {
          if (ev.type === 'startDrag') {
            self.manager.tracking = true;
            self.onInitDrag();
            self.fireEvent('startMove', this.elm);
          } else if (ev.type === 'endDrag') {
            self.manager.tracking = false;
            self.manager.undoRegistered = false;
            self.fireEvent('stopMove', this.elm);
          } else if (ev.type === 'drag') {
            self.onBeforeDrag();
            self.onDrag(ev);
          }//TODO: else...
        });
  },

  setLineVisibility: function(b) {
    this.line.style.display = b ? 'block' : 'none';
  },

  remove: function($super) {
    $super();

    // When this boundary control is removed, remove its subscription to the UI binding,
    // which is shared among all boundary controls of a given actsOn value
    if (this._rxUiSubscription) {
      this._rxUiSubscription.dispose();
    }
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/element_boundary_control.js
// module id = 1017
// module chunks = 0